// ======================================================================
// File Name       : TabMenuAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionTypes from '../constants/actionTypes/tabMenu';

export function saveActiveTabMenu(key) {
  return {
    type: actionTypes.TABMENU_SAVE_ACTIVE_TAB,
    key,
  };
}
